<div id="rendererContainer" #rendererContainer [ngClass]="{'show': loaded }"></div>